module.exports = __webpack_public_path__ + "img/featureicon5.2b793024.svg";